import type { ScheduleOption } from '../graphqlEnums'

import { useIsChannelLessDraftMode } from '../hooks/useIsChannelLessDraftMode'
import type { SaveCallbacks } from './types'
import { useContentItemDraftSave } from './useContentItemDraftSave'
import { useGraphCallbacks } from './useGraphCallbacks'

/**
 * All saves go through the GraphQL path. When the channel-agnostic drafts
 * feature is on and no real channel is selected (including preview mode, where
 * selectable channels are placeholders), Save Draft saves the channel-less omni
 * draft via createContentItemDraft instead.
 */
export const useSaveCallbacks = (
  option: ScheduleOption = 'Queue',
  scheduledAt: number | null = null,
  initialScheduledAt: number | null = null,
): SaveCallbacks => {
  const graphql = useGraphCallbacks(option, scheduledAt, initialScheduledAt)
  const channelLessDraftSave = useContentItemDraftSave(option, scheduledAt)
  const useChannelLessDraftSave = useIsChannelLessDraftMode()

  return useChannelLessDraftSave
    ? { ...graphql, saveAsDraft: channelLessDraftSave }
    : graphql
}
